import { Box, Flex } from '@chakra-ui/react';
import { faBriefcase, faUmbrellaBeach } from '@fortawesome/free-solid-svg-icons';
import { EditActivityUpdateModel } from '../schema/editActivitySchema';
import { UseFormReturn, useWatch } from 'react-hook-form';
import { HotelBookingType } from '../../../../../globalModels/common/hotelBookingType';
import { BaseFields, BaseIcon, BaseTooltip } from '@invara-dev/react-base';

type Props = {
  formMethods: UseFormReturn<Partial<EditActivityUpdateModel>>;
  isDisabled?: boolean;
};

export const PersonalCompanyToggle = (props: Props) => {
  const bookingType = useWatch({
    control: props.formMethods.control,
    name: 'HotelBookingType'
  });

  const isPersonal = bookingType == HotelBookingType.Personal;

  return (
    <Box minW='fit-content' flexShrink={0}>
      <Flex gap='8px' alignItems='center' flexShrink={0}>
        <BaseFields.SwitchInput
          checked={isPersonal}
          disabled={props.isDisabled}
          onChangeControlled={(e) => {
            props.formMethods.setValue('HotelBookingType', e ? HotelBookingType.Personal : HotelBookingType.Business);
            props.formMethods.setValue('TravelerIds', []);
          }}
        />
        <BaseTooltip
          content={
            props.isDisabled
              ? `${isPersonal ? 'Personal' : 'Business'} (booking type is locked once the activity is booked)`
              : isPersonal
                ? 'Personal'
                : 'Business'
          }>
          <Box display='inline-flex' alignItems='center' lineHeight={0}>
            <BaseIcon icon={isPersonal ? faUmbrellaBeach : faBriefcase} fontSize='md' />
          </Box>
        </BaseTooltip>
      </Flex>
    </Box>
  );
};
